import { VisitCountModel } from 'dibs-visit-tracking';
import { PRIORITIES } from '../pdpRespNotificationConstants';

/**
 * Rule workflow:
 *
 * Return true if it's the first page visit, so it prevents other callouts.
 */

const { PREVENT_ON_FIRST_VISIT_PRIORITY } = PRIORITIES;

export const pdpRespNotificationPreventOnFirstVisitConfig = {
    name: 'preventOnFirstVisit',
    priority: PREVENT_ON_FIRST_VISIT_PRIORITY,
    rule: () => {
        const visitCountModel = new VisitCountModel();

        return Promise.resolve(!visitCountModel.get('totalVisitCount'));
    },
    action: () => ({ type: null }),
};
